export default "__VITE_ASSET__rBJKI9hn__"